// This file is generated by a script. Do not edit this file directly.
var _excluded = ["className", "type", "label", "error", "labelClassName", "errorClassName", "containerClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { cn } from "../../common/utils";
import { inputClasses } from "./Base";
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    type = _ref.type,
    label = _ref.label,
    error = _ref.error,
    labelClassName = _ref.labelClassName,
    errorClassName = _ref.errorClassName,
    containerClassName = _ref.containerClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, label && /*#__PURE__*/React.createElement("label", {
    className: cn('cop-text-sm cop-font-bold', labelClassName)
  }, label), /*#__PURE__*/React.createElement("input", _extends({
    type: type,
    className: cn(inputClasses, error ? 'cop-border-red-600' : '', label ? 'cop-mt-1' : '', className),
    ref: ref
  }, props)), error && /*#__PURE__*/React.createElement("div", {
    className: cn('cop-text-right cop-text-sm cop-text-danger', errorClassName)
  }, error));
});
Input.displayName = 'Input';
export { Input };
